import React, { useContext } from 'react'
import PointsSection from './PointsSection'
import InformationSection from './InformationSection'
import RewardCatalog from './RewardCatalog/'
import styled from 'styled-components'
import ShareButton from '../../../influencerComponents/ShareButton'
import Influencing from './Influencing'
import RecentActivity from './RecentActivity/'
import JoinedBrands from './JoinedBrands'
import Card from 'react-bootstrap/Card'

const DashboardContainer = styled.div``
const Points = styled.h2`
  color: #212529;
  font-weight: 500;
  line-height: 1.5em;
  display: inline-block;
  @media screen and (max-width: 576px) {
    font-size: 1.25em;
    padding: 1.5em 0 0.8em;
  }
`

function DashboardPage() {
  return (
    <DashboardContainer className="animated fadeIn">
      <div className="actions-container pt-sm-3">
        <Points>My Points</Points>
        {/*<ShareButton />*/}
      </div>
      <div className="clearfix" />
      <div className="mt-5" />
      <PointsSection />
      <RecentActivity />
      <JoinedBrands />
      {/*<Influencing />*/}
      {/*<InformationSection />*/}
      {/*<RewardCatalog />*/}
    </DashboardContainer>
  )
}

export default DashboardPage
